/** Quantos itens por página (10/25/50/100) — escolha da pessoa, lembrada no navegador, vale em todo o sistema. */
import { create } from "zustand";

export const PAGE_SIZES = [10, 25, 50, 100] as const;
const KEY = "vg:por-pagina";
const initial = (() => { try { const n = Number(localStorage.getItem(KEY)); return (PAGE_SIZES as readonly number[]).includes(n) ? n : 25; } catch { return 25; } })();

export const usePageSizeStore = create<{ size: number; set: (n: number) => void }>((set) => ({
  size: initial,
  set: (n) => { try { localStorage.setItem(KEY, String(n)); } catch { /* sem armazenamento */ } set({ size: n }); },
}));

export function usePageSize(): number { return usePageSizeStore((s) => s.size); }
